import Head from 'next/head'

import { Card } from '@/components/Card'
import { SimpleLayout } from '@/components/SimpleLayout'
import { formatDate } from '@/lib/formatDate'
import { getAllArticles } from '@/lib/getAllArticles'
import {useRouter} from "next/router";
import {useIntl} from "react-intl";
import {useEffect} from "react";

function Article({ article }) {
  return (
    <article className="md:grid md:grid-cols-4 md:items-baseline">
      <Card className="md:col-span-3">
        <Card.Title href={`/articles/${article.slug}`}>
          {article.title}
        </Card.Title>
        <Card.Eyebrow
          as="time"
          dateTime={article.date}
          className="md:hidden"
          decorate
        >
          {formatDate(article.date)}
        </Card.Eyebrow>
        <Card.Description>{article.description}</Card.Description>
        <Card.Cta>Read article</Card.Cta>
      </Card>
      <Card.Eyebrow
        as="time"
        dateTime={article.date}
        className="mt-1 hidden md:block"
      >
        {formatDate(article.date)}
      </Card.Eyebrow>
    </article>
  )
}

export default function ArticlesIndex({ articles }) {
  const router = useRouter();
  const intl = useIntl();
  const SimpleLayoutTitle = intl.formatMessage({ id: 'articles.page.simple.layout.title' });
  const SimpleLayoutIntro = intl.formatMessage({ id: 'articles.page.simple.layout.intro' });

  useEffect(() => {
    if (router) {
      router.events.on('routeChangeComplete', () => {
        window.location.reload();
      });
    }
  }, [router]);

  return (
    <>
      <Head>
        <title>Articles - Rahimi Diallo</title>
        <meta
          name="description"
          content={SimpleLayoutIntro}
        />
      </Head>
      <SimpleLayout
        title={SimpleLayoutTitle}
        intro={SimpleLayoutIntro}
      >
        <div className="md:border-l md:border-zinc-100 md:pl-6 md:dark:border-zinc-700/40">
          <div className="flex max-w-3xl flex-col space-y-16">
            {articles.filter((article) => article.locale === router.locale).map((article) => (
              <Article key={article.slug} article={article} />
            ))}
          </div>
        </div>
      </SimpleLayout>
    </>
  )
}

export async function getStaticProps() {
  return {
    props: {
      articles: (await getAllArticles()).map(({ component, ...meta }) => meta),
    },
  }
}
